<!-- src/components/booking/BookingWidget.vue -->
<!-- Combined booking widget for reservations and takeaway orders -->
<template>
  <div class="booking-widget p-6 max-w-md mx-auto">
    <!-- Two column layout for booking options -->
    <div class="flex flex-col items-center text-center grid gap-6">
      <!-- Book a Table Section -->
      <div class="flex flex-col items-center text-center p-3 w-full space-y-3">
        <button
          @click="openBookingModal"
          class="rl w-full flex items-center justify-center px-8 py-3 border-2 border-sg text-base font-medium text-white hover:bg-pb hover:bg-opacity-50"
        >
          Book a table now
        </button>
        <a
          href="/takeaway"
          class="rl w-full flex items-center justify-center px-8 py-3 border-2 border-sg text-base font-medium text-white hover:bg-pb hover:bg-opacity-50"
        >
          Collection & Delivery
        </a>
      </div>
      <!-- Collection & Delivery Section -->
    </div>
  </div>
</template>

<script>
import { openTableEventBus } from "@/utils/eventBus";

export default {
  name: "BookingWidget",
  methods: {
    openBookingModal() {
      // Trigger the global OpenTable modal
      openTableEventBus.emit("open");
    },
  },
};
</script>

<style>
/* Apple glass (glassmorphism) effect for the booking widget */
/* Using sg gold color (#AA9D75) from tailwind config */
.booking-widget {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 2px solid #aa9d75;
  box-shadow: 0 0 20px rgba(170, 157, 117, 0.4),
    0 0 40px rgba(170, 157, 117, 0.2);
}
</style>
